import {
  INIT_STICKER_CATEGORY_ID,
  ITEM_CATEGORY_SELECTABLE_PER_PAGE,
  ITEM_SELECTABLE_PER_PAGE,
  SHOOTING_TYPES,
  VERTICAL_SCREEN_ITEM_SELECTABLE_PER_PAGE,
  VERTICAL_SCREEN_VERTICAL_FRAME_ITEM_SELECTABLE_PER_PAGE,
} from 'constants/photo.const';
import { useBoothAppContext } from 'context/BoothAppContext';
import { useSoundContext } from 'context/SoundContext';
import { isHigher } from 'helpers/math.helper';
import { isEqualVal } from 'helpers/string.helper';
import { filter, map } from 'lodash';
import React, { useMemo } from 'react';
import { setSelfeAppStateAction } from 'store/features/app/selfeAppSlice';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import EditPhotoGridSelectItem from '../edit-photo/EditPhotoGridSelectItem';
import EditPhotoSelectCategory from '../edit-photo/EditPhotoSelectCategory';
import EditPhotoSheetPreview from '../edit-photo/EditPhotoSheetPreview';
import './select-sticker.css';

function SelectSticker() {
  const dispatch = useAppDispatch();
  const { audio } = useSoundContext();
  const { listStickerCategoryPhotos, currentLayout, listStickerPhotos } =
    useBoothAppContext();
  const {
    stickerCategoryId,
    listSelectedSticker,
    shootingModeId,
    photoContainer,
  } = useAppSelector((state) => state.selfeApp);
  const { isVerticalScreen } = useAppSelector((s) => s.booth);
  const isHasVideo =
    !shootingModeId || isEqualVal(shootingModeId, SHOOTING_TYPES.COUNTDOWN);

  const handleSelectSticker = (id: number, link: string) => {
    audio?.playClickToSelect?.();
    const NumberIdSimilar = map(
      filter(listSelectedSticker, (e) => e.stickerId === id),
      (e) => e.stickerId,
    );
    const newSticker = [
      ...listSelectedSticker,
      {
        stickerId: id,
        idUnique:
          listSelectedSticker.findIndex((e: any) => e.stickerId === id) !== -1
            ? `${id}-${NumberIdSimilar.length}`
            : id.toString(),
        image: link,
        width: 100,
        height: 100,
        rotate: 0,
        translate: [
          (photoContainer?.clientWidth || 0) / 2 - 50,
          (photoContainer?.clientHeight || 0) / 2 - 50,
        ],
      },
    ];
    dispatch(setSelfeAppStateAction({ listSelectedSticker: newSticker }));
  };

  const handleSelectCategory = (category: number | undefined) => {
    if (category) {
      audio?.playClickToSelect?.();
      dispatch(setSelfeAppStateAction({ stickerCategoryId: category }));
    }
  };

  React.useEffect(() => {
    !stickerCategoryId &&
      dispatch(
        setSelfeAppStateAction({
          stickerCategoryId:
            listStickerCategoryPhotos?.data?.[0]?.id ||
            INIT_STICKER_CATEGORY_ID,
        }),
      );
  }, [dispatch, listStickerCategoryPhotos, stickerCategoryId]);

  const isVerticalFrame = useMemo(
    () => isHigher(currentLayout?.height, currentLayout?.width),
    [currentLayout],
  );

  // Số theme item trên 1 page
  const stickerPerPage = useMemo(() => {
    const verticalItemPerPage = isVerticalFrame
      ? VERTICAL_SCREEN_VERTICAL_FRAME_ITEM_SELECTABLE_PER_PAGE
      : VERTICAL_SCREEN_ITEM_SELECTABLE_PER_PAGE;

    return isVerticalScreen ? verticalItemPerPage : ITEM_SELECTABLE_PER_PAGE;
  }, [isVerticalScreen, isVerticalFrame]);

  return (
    <>
      <div className="sticker-page edit-page">
        <EditPhotoSelectCategory
          selectedCatId={stickerCategoryId}
          listCatData={listStickerCategoryPhotos}
          catPerPage={ITEM_CATEGORY_SELECTABLE_PER_PAGE}
          onSelectCategory={handleSelectCategory}
        />
        <div className="edit-page__selection-section">
          <EditPhotoSheetPreview
            isShowWarningNotShowingOnVideo={isHasVideo}
            isInStickerPage
          />
          <EditPhotoGridSelectItem
            listData={listStickerPhotos}
            itemPerPage={stickerPerPage}
            onSelectItem={handleSelectSticker}
          />
        </div>
      </div>
    </>
  );
}

export default SelectSticker;
